export const getUser = state => {
    return state.user.user;
}

export const getCurrentSolution = state => {
    return state.order.solution;
}

export const getOrderState = state => {
    return state.order;
}

export const getCustomerCar = state => {
    return state.order.customer.carModel;
}

export const getCustomer = state => {
    return state.order.customer;
}

export const getHttp = state => {
    return state.http.http;
}


export const getField = (state) => (field) => {

    if (field.store === "customer") {
        return state.order.customer[field.key];
    }

    if (field.store === "order") {
        return state.order[field.key];
    }

}
